import React from 'react';
import { Modal } from '@upgrade/react-components';

import { Heading } from '../../common/TypographyPublicSite';
import Jotform from '../../common/Jotform';

const PartnerFormModal = ({ close, scriptSrc, ...props }) => {
  return (
    <Modal onClose={close} {...props}>
      <Heading as="h2" align="center">
        Interested in partnering with Flex Pay? Answer a few questions here.
      </Heading>
      <Jotform scriptSrc={scriptSrc} />
    </Modal>
  );
};

export default PartnerFormModal;
